export default __webpack_public_path__ + "5c30c5d77c70f78054464c710c797d29.svg";